module.exports = __webpack_public_path__ + "dashboard/img/collector.561b1f2fa8c391a08f03f4711e2ba04c.svg";